"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class AWSHelperError extends Error {
    constructor(message, awsErrorMessage, errorFields) {
        super(message);
        this.message = message;
        this.awsErrorMessage = awsErrorMessage;
        this.S3DocumentKey = errorFields.S3DocumentKey;
        this.S3BucketKey = errorFields.S3BucketKey;
        this.S3Operation = errorFields.S3Operation;
        this.S3Params = errorFields.S3Params;
        this.SnsMessage = errorFields.SnsMessage;
        this.SnsTopic = errorFields.SnsTopic;
        this.SqsQueueName = errorFields.SqsQueueName;
        this.SqsQueueUrl = errorFields.SqsQueueUrl;
        this.SqsMessageBody = errorFields.SqsMessageBody;
        this.SqsReceiptHandle = errorFields.SqsReceiptHandle;
        this.SsmParameter = errorFields.SsmParameter;
        this.SsmParameters = errorFields.SsmParameters;
        this.SesSource = errorFields.SesSource;
        this.SesToAddress = errorFields.SesToAddress;
        this.SesMessageSubject = errorFields.SesMessageSubject;
        this.StepFunctionArn = errorFields.StepFunctionArn;
        Object.setPrototypeOf(this, AWSHelperError.prototype);
    }
    message;
    awsErrorMessage;
    S3DocumentKey;
    S3BucketKey;
    S3Operation;
    S3Params;
    SnsMessage;
    SnsTopic;
    SqsQueueName;
    SqsQueueUrl;
    SqsMessageBody;
    SqsReceiptHandle;
    SsmParameter;
    SsmParameters;
    SesSource;
    SesToAddress;
    SesMessageSubject;
    StepFunctionArn;
}
exports.default = AWSHelperError;
